var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.230469,
    y: 0.394287,
    width: 49.5393,
    height: 50.1343,
    rx: 8,
    fill: "#EDFFFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_324_1350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.263 24.41H21.5788V20.4626C21.5788 18.5763 23.1135 17.0416 24.9998 17.0416C26.8862 17.0416 28.4209 18.5763 28.4209 20.4626V22.0416C28.4209 22.4776 28.7744 22.8311 29.2104 22.8311C29.6464 22.8311 29.9998 22.4776 29.9998 22.0416V20.4626C29.9998 17.7056 27.7568 15.4626 24.9998 15.4626C22.2428 15.4626 19.9998 17.7056 19.9998 20.4626V24.41H19.7367C19.01 24.41 18.4209 24.9991 18.4209 25.7258V34.1469C18.4209 34.8735 19.01 35.4626 19.7367 35.4626H30.263C30.9897 35.4626 31.5788 34.8735 31.5788 34.1469V25.7258C31.5788 24.9991 30.9897 24.41 30.263 24.41ZM23.4209 28.8837C23.4209 28.0116 24.1278 27.3048 24.9998 27.3048C25.8718 27.3048 26.5788 28.0116 26.5788 28.8837C26.5788 29.4681 26.2612 29.9779 25.7893 30.2509V32.5679H24.2104V30.2509C23.7385 29.9779 23.4209 29.4681 23.4209 28.8837Z",
    fill: "#03997B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324_1350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(15 15.4626)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0ca42764d92dcd738a9b91ffea79c901.svg";
export { ForwardRef as ReactComponent };